export default __webpack_public_path__ + "assets/eeb83dd1581c2f3d4b627e83b73a2bb1.woff2";